import {Avatar, Box, capitalize, DialogActions, DialogContent, Link, Paper, Typography} from "@mui/material";
import {Form, Formik, FormikProps} from "formik";
import SubmitButton from "../../components/SubmitButton";
import {useOnboardingHandling} from "../../hooks/onboarding/useOnboardingHandling";
import {onboardingStyles} from "../../styles/onboarding/onboarding.styles";
import {useOnboardingForm} from "../../hooks/onboarding/useOnboardingForm";
import FieldsContentOnboarding from "../../components/onboarding/FieldsContentOnboarding";
import {OnboardingCallDaten} from "../../api";
import GuudeIcon from '/favicon.svg?url';

export default function PageCreateOnboardingCall() {
    const {translation} = useOnboardingHandling();
    const formikProps = useOnboardingForm();

    return (
        <Box id={'page-create-onboarding-call-frame'}
             sx={onboardingStyles.pageCreateOnboardingCall.frame}
        >
            <Paper id={'page-create-onboarding-call-paper'}
                   elevation={1}
                   sx={onboardingStyles.pageCreateOnboardingCall.paper}
            >
                <Formik {...formikProps}>
                    {({isSubmitting, isValidating, isValid, dirty, values}: FormikProps<OnboardingCallDaten>) => (
                        <Form id={'form-create-onboarding-call'}>
                            <Box sx={onboardingStyles.pageCreateOnboardingCall.header}>
                                <Link href="https://guude.ai" target="_blank">
                                    <Avatar src={GuudeIcon} alt="Guude AI Icon"
                                            sx={onboardingStyles.pageCreateOnboardingCall.appIcon}/>
                                </Link>
                                <Typography variant="h5">
                                    {capitalize(translation('welcome-title'))}
                                </Typography>
                                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                                    {capitalize(translation('onboarding-explanation'))}
                                </Typography>
                            </Box>
                            <DialogContent id={'page-create-onboarding-call-dialog-content'}>
                                <FieldsContentOnboarding/>
                            </DialogContent>
                            <DialogActions id={'page-create-onboarding-call-dialog-actions'}>
                                <SubmitButton id={'page-create-onboarding-call-submit-button'}
                                              form={'form-create-onboarding-call'}
                                              type={'submit'}
                                              variant={'contained'}
                                              color={'primary'}
                                              loading={isSubmitting}
                                              disabled={isValidating || !isValid || !dirty || !values.telefonnummerBestaetigt || !values.datenschutzBestaetigt}
                                >
                                    {isSubmitting ? capitalize(translation('sending')) : capitalize(translation('send'))}
                                </SubmitButton>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
                <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <Link href="https://guude.ai/impressum" target="_blank" underline="hover">
                        {capitalize(translation('imprint'))}
                    </Link>
                </Box>
            </Paper>
        </Box>
    );
}
